<template>
  <keep-alive>
    <div class="search" v-cloak>
      <div style="background:#fce6d9">
        <div class="detai_box_img" v-show="!showImg"></div>
      </div>
      <div class="box_search">
        <div class="box_shuqain">
          <div class="rel_commodity">
            <div>
              <el-menu
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
                background-color="#fff"
                text-color="#000"
                active-text-color="#ec9368"
              >
                <el-menu-item index="1">产品列表</el-menu-item>
                <el-submenu index="2">
                  <template slot="title">品牌专区</template>
                  <el-menu-item index="2-1">三米柜台</el-menu-item>
                  <el-menu-item index="2-2">新零售</el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
            <div class="searchBox">
              <el-input
                class="box_input"
                prefix-icon="el-icon-search"
                v-model="keyword"
                @keyup.enter.native="getFilterKeywords()"
              ></el-input>
              <el-button class="box_serar" @click="getFilterKeywords()"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </keep-alive>
</template>

<script>
import bus from "@/utils/bus";
export default {
  name: "transferMap",
  props: ["showImg"],
  data() {
    return {
      keyword: "",
      activeIndex: "1",
    };
  },
  mounted() {
    bus.$on("keyword", (item) => {
      this.keyword = item;
    });
  },
  methods: {
    getFilterKeywords() {
      localStorage.setItem("title", "getFilterKeywords");
      localStorage.setItem("val", this.keyword);
      bus.$emit("message", this.keyword);
      this.$router.push({
        name: "home",
      });
    },
    handleSelect(key, keyPath) {
      bus.$emit("handleSelect", key);
    },
  },
};
</script>

<style>
[v-cloak] {
  display: none;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 116px !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
}
.el-menu--horizontal > .el-menu-item {
  height: 50px !important;
  line-height: 50px !important;
}
.box_shuqain .box_serar {
  background-color: #ec9368;
  width: 74px;
  padding: 6px;
  position: relative;
  /* top: 1px; */
  left: -1px;
  height: 34px;
  font-size: 18px;
  color: #fff;
}
.box_input .el-input__inner {
  height: 34px !important;
  padding-left: 50px !important;
  background-color: #fff !important;
  border-radius: 0px !important;
  border: 1px solid #ec9368;
}
.box_input .el-icon-search:before {
  font-size: 18px;
}
.box_input .el-input__inner::placeholder {
  padding-left: 10px;
  color: #999;
  font-size: 18px !important;
}
.box_input .el-input__prefix {
  left: 24px;
}
.el-input__inner:focus,
.el-input__inner:hover {
  border: 1px solid #ec9368 !important;
  background: #fff !important;
}
</style>

<style scoped>
::v-deep .el-input__icon {
  line-height: 0 !important;
}
::v-deep .el-input__prefix,
.el-input__suffix {
  line-height: 35px !important;
  height: 35px !important;
}
.bottom_chanping {
  width: 116px;
  padding-top: 15px;
  border-bottom: 2px solid #ec9368;
}
.searchBox {
  width: 394px;
  font-size: 0;
  height: 50px;
  display: flex;
  align-items: center;
}
.el-button {
  border: 1px solid #ec9368;
}
.box_input {
  height: 34px;
  width: 320px;
  /* line-height: 50px; */
}
.box_search {
  width: 1200px;
  margin: 0 auto;
  height: 50px;
}
.el-button:focus,
.el-button:hover {
  background: #ec9368;
  color: #fff;
  border: none;
}
.detai_box_img {
  background-image: url("../../Img/detaile/benner.png");
  width: 1200px;
  /* height:40%; */
  /* background-size: 100% 100%; */
  display: flex;
  height: 304px;
  margin: 0 auto;
}

.search .box_shuqain {
  width: 100%;
  box-shadow: 0px 8px 12px #f5f5f5;
}
.rel_commodity {
  display: flex;
  height: 50px;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}
.Product {
  cursor: pointer;
  font-size: 14px;
  color: #ec9368;
  padding-top: 16px;
  width: 100%;
  padding-right: 64px;
  text-align: center;
  /* line-height: 30px; */
  /* color: #ccac70; */
  /* border-bottom: 2px solid #ccac70; */
}
.Product_two {
  cursor: pointer;
  font-size: 14px;
  padding-top: 16px;
  text-align: center;
  width: 100%;
}
.Product_zhiding {
  cursor: pointer;
  font-size: 14px;
  padding-top: 16px;
  text-align: center;
  width: 100%;
}
</style>
